const bar = document.querySelector('[data-sticky-bar]');

if (bar) {
  const SHOW_AFTER_PX = 480;
  let visible = false;

  const update = () => {
    const shouldShow = window.scrollY > SHOW_AFTER_PX;
    if (shouldShow === visible) return;
    visible = shouldShow;
    bar.classList.toggle('sticky-bar--visible', visible);
  };

  update();
  window.addEventListener('scroll', update, { passive: true });
}
